import { NavigationState, Route } from "@react-navigation/native";

// gets the current screen from navigation state
export const getActiveRoute = (
  navigationState: Omit<NavigationState, "key" | "routeNames">
): Route<string> | null => {
  if (!navigationState) {
    return null;
  }
  const route = navigationState.routes[navigationState.index];
  // dive into nested navigators
  if (
    `state` in route &&
    route.state &&
    `index` in route.state &&
    typeof route.state.index === "number"
  ) {
    return getActiveRoute(route.state as any);
  }
  return route;
};
